const getLocalISOString = () => `${new Date(+new Date() + 8 * 3600 * 1000).toISOString().slice(0, -1)}+08:00`;

export {
  getLocalISOString,
};
